﻿$.fn.dxCtrlSaisieEmetteurSms = function custom_dxCtrlSaisieEmetteurSms(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsaisieemetteursms dx-ctrl");
        this.createInstance(new cdxCtrlSaisieEmetteurSms(this, option));
    }
    return this;
}

window.cdxCtrlSaisieEmetteurSms = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        if (option.afficheAide) $("<div style='font-size:80%;'>Nom de l'expéditeur affiché à votre correspondant pour l'envoi de vos SMS. (Entre 4 et 11 caractères, uniquement des lettres et des chiffres, pas uniquement des chiffres). Si vide, l'émetteur affiché sera <b>'" + parametre.nom + "'</b>.</div>").appendTo(container)
        var dx = $("<div/>").appendTo(container).dxCtrlTextBox({
            label: "Emetteur",
            labelMode: 'floating',
            placeholder: parametre.nom,
            maxLength: 11,
            noDataText: "",
            value: option.value,
            inputAttr: { 'style': "text-transform: uppercase" },
            onKeyDown: function (e) {
                var event = e.event;
                var keyCode = event.keyCode;

                // The next commented line is for debugging purposes:
                //console.log(keyCode);

                // Allow: Backspace, Delete, Tab, Escape, Enter and '.'
                if ($.inArray(keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                    // Allow: Ctrl+A
                    (keyCode == 65 && event.ctrlKey === true) ||
                    // Allow: Ctrl+C
                    (keyCode == 67 && event.ctrlKey === true) ||
                    // Allow: Ctrl+X
                    (keyCode == 88 && event.ctrlKey === true) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 39)) {
                    // Let it happen, don't do anything
                    return;
                }

                // Ensure that it is a letter and stop the keypress otherwise
                var key = event.key
                var ascii = key.charCodeAt(0)
                if ((ascii >= 48 && ascii <= 57) || (ascii >= 65 && ascii <= 90) || (ascii >= 97 && ascii <= 122)) {
                    //ok
                } else {
                    event.preventDefault(); //KO
                }
            },
            onValueChanged: function (e) {
                if (e.value != null && e.value.length > 0) {
                    if (e.value.length <= 3) {
                        e.component.option("value", option.bddCtrl.paraAppli.mGetPara("sms_emetteur"))
                        mNotify("L'émetteur doit faire plus de 3 caractères", "error", 5000)
                    } else if (e.value.length >= 12) {
                        e.component.option("value", option.bddCtrl.paraAppli.mGetPara("sms_emetteur"))
                        mNotify("L'émetteur doit faire moins de 12 caractères", "error", 5000)
                    } else if ($.isNumeric(e.value)) {
                        e.component.option("value", option.bddCtrl.paraAppli.mGetPara("sms_emetteur"))
                        mNotify("L'émetteur ne peut pas contenir que des chiffres", "error", 5000)
                    } else {
                        var ok = true
                        for (var i = 0; i < e.value.length; i++) {
                            var ascii = e.value.charCodeAt(i)
                            if ((ascii >= 48 && ascii <= 57) || (ascii >= 65 && ascii <= 90) || (ascii >= 97 && ascii <= 122)) {
                                //ok
                            } else {
                                //ko
                                ok = false
                            }
                        }
                        if (!ok) {
                            e.component.option("value", option.value)
                            mNotify("L'émetteur contient des caractères interdit", "error", 5000)
                        } else {
                            option.value = e.value
                            option.onValueChanged({ value: e.value.toUpperCase() })
                        }
                    }
                } else {
                    option.value = ""
                    option.onValueChanged({ value: "" })
                }

            }
        })
    }

    this.focus = function () { }

    this.element = function () { return container }

    mConstruit();
}